import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';

export class UnservedReason extends Enum {
  static DEATH = {
    key: 'death',
    get value() {
      return Lang.t('beneficiary.beneficiary-died');
    }
  };

  static UNFOUND = {
    key: 'unfound',
    get value() {
      return Lang.t('beneficiary.beneficiary-is-found');
    }
  };

  static OTHER = {
    key: 'other',
    get value() {
      return Lang.t('asset.other');
    }
  };
}
